module.exports = __webpack_public_path__ + "static/media/logo_wp.1ced4613.svg";